import { get, post } from "_src/utils/http";

// 获取用户相关信息
export function authorized(data) {
  return get("/api/inftspace/users/v1/authorized", data).then((res) => {
    return res;
  });
}

// 获取用户余额
export function getUserBalanceList(data) {
  return post("/api/inftspace/users/v1/get_user_balance_list", data).then((res) => {
    return res;
  });
}

// 获取用户相关信息
export function validNickname(data) {
  return get("/api/inftspace/users/v1/valid_nickname", data).then((res) => {
    return res;
  });
}

export function getUserBalance(data) {
  return post("/api/inftspace/users/v1/get_user_balance", data).then((res) => {
    return res;
  });
}

// activity 表格
export function getUserActivity(data) {
  return get("/api/inftspace/users/v1/get_user_activity", data).then((res) => {
    return res;
  });
}

// 获取用户相关信息 address
export function getUserMessage(data) {
  return get("/api/inftspace/users/v1/get_info", data).then((res) => {
    return res;
  });
}

// 获取用户相关信息 userName
export function getUserMessage_name(data) {
  return get("/api/inftspace/users/v1/get_name_info", data).then((res) => {
    return res;
  });
}

// 设置用户相关信息
export function setInfo(data) {
  return post("/api/inftspace/users/v1/set_info", data).then((res) => {
    return res;
  });
}

// 全球支付获取参数配置
export function config(data) {
  return get("/api/inftspace/payment/v1/config", data).then((res) => {
    return res;
  });
}
